export default __webpack_public_path__ + "static/media/mbl_discord.2e292fa0.png";